import * as react from 'react';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { InputNumber } from 'primereact/inputnumber';
import { InputText } from 'primereact/inputtext';
import { useRef, useState } from 'react';
import { Divider } from 'primereact/divider';
import { Checkbox } from 'primereact/checkbox';
import { testMail } from '../../service/emailSettings/EmailSettingsServices';
import { useDispatch, useSelector } from 'react-redux';
import { Toast } from 'primereact/toast';
import { AppMode } from "../../data/AppMode";
import { ThemeState } from "../../dtos/common/ThemeState";
import { AppModeState } from '../../dtos/common/AppModeState';
import { findSettingsByKey, findUpdateAndCreateSettings } from '../../service/common/commonService';
import { Host, Port, MailUserName, MailPassword, MailFrom, MailBody } from '../../shared/constant/MailValue';
import { Toolbar } from 'primereact/toolbar';

export const EmailSettings = () => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars

    const themeName = useSelector((state: ThemeState) => state.theme.themeName);
    const modeName = useSelector((state: AppModeState) => state.theme.appMode);
    const mode = AppMode.find(md => md.name === modeName);
    const [fromAdd, setFromAdd] = useState('admin');
    const [toAdd, setToAdd] = useState('');
    const [host, setHost] = useState('127.0.0.1');
    const [port, setPort] = useState<number>(25);
    const [displayName, setDisplayName] = useState('INVOICE');
    const [userName, setUserName] = useState('');
    const [password, setPassword] = useState('');
    const [ssl, setSsl] = useState<boolean>(true);
    const dispatch = useDispatch();
    const toast = useRef<any>(null);
    const localization = useSelector(
        (state: any) => state.localization.localization
    );
    const userId = localStorage.getItem("userId")
    const tenantId = localStorage.getItem("tenantId")
    const [disableBtn, setDisableBtn] = useState<boolean>(false);

    const handleTestMail = async () => {
        const input = {
            Host: host,
            Port: port,
            MailFrom: fromAdd,
            MailTo: toAdd,
            Subject: displayName,
            Message: 'HI',
            MailUserName: userName,
            MailPassword: password
        }

        if (userName.length === 0 || password.length === 0 || toAdd.length === 0) {
            toast.current.show({ severity: 'warn', summary: 'Warning', detail: 'Please complete all the fields to send a test mail!', life: 3000 });
            return;
        }
        const result = await testMail(dispatch, input);
        await getAllInputs()
        toast.current.show({ severity: 'success', summary: 'Success', detail: result, life: 3000 });
    }

    const getAllInputs = async () => {
        const [hostInput, portInput, fromAddInput, smtpUserName] = await Promise.all([
            findSettingsByKey(dispatch, { key: Host }),
            findSettingsByKey(dispatch, { key: Port }),
            findSettingsByKey(dispatch, { key: MailFrom }),
            findSettingsByKey(dispatch, { key: MailUserName }),
            // findSettingsByKey(dispatch, { key: MailPassword })
        ]);

        setHost(hostInput?.value);
        setPort(portInput?.value);
        setFromAdd(fromAddInput?.value);
        setUserName(smtpUserName?.value);
        setPassword('*****')

        if (!hostInput || !portInput || !smtpUserName) {
            setDisableBtn(true)
        }
        else {
            setDisableBtn(false)
        }
    }

    const handleSave = async () => {
        if (userName.length === 0) {
            toast.current.show({ severity: 'warn', summary: 'Warning', detail: 'Please provide an username for save the details', life: 3000 });
            return;
        }
        if (fromAdd.length === 0) {
            toast.current.show({ severity: 'warn', summary: 'Warning', detail: 'Please provide an from address for save the details', life: 3000 });
            return;
        }

        if (password.length === 0 || password === '*****') {
            toast.current.show({ severity: 'warn', summary: 'Warning', detail: 'Please provide a password for save the details', life: 3000 });
            return;
        }

        if (host.length === 0) {
            toast.current.show({ severity: 'warn', summary: 'Warning', detail: 'Please provide a host name for save the details!', life: 3000 });
            return;
        }
        if (port === null) {
            toast.current.show({ severity: 'warn', summary: 'Warning', detail: 'Please provide a port for save the details!', life: 3000 });
            return;
        }
        const validTenantId = tenantId === "null" || tenantId === null ? null : JSON.parse(tenantId)

        await Promise.all([
            findUpdateAndCreateSettings(dispatch, { userId: null, tenantId: validTenantId, name: MailUserName, value: userName }),
            findUpdateAndCreateSettings(dispatch, { userId: null, tenantId: validTenantId, name: MailPassword, value: password }),
            findUpdateAndCreateSettings(dispatch, { userId: null, tenantId: validTenantId, name: Port, value: port.toString() }),
            findUpdateAndCreateSettings(dispatch, { userId: null, tenantId: validTenantId, name: Host, value: host }),
            findUpdateAndCreateSettings(dispatch, { userId: null, tenantId: validTenantId, name: MailFrom, value: fromAdd }),
        ]);

        await getAllInputs();

        toast.current.show({ severity: 'success', summary: 'Success', detail: 'You have successfully save the details!', life: 3000 });
    }

    const startToolBar = () => {
        return (
            <div>
                <h4 className="text-lg font-semibold text-gray-800 dark:text-gray-200 mb-0 mt-0">
                    {localization?.MailSettings || "Mail Settings"}
                </h4>
            </div>
        );
    }

    react.useEffect(() => {
        getAllInputs()
    }, [])

    return (
        <div className="w-full">
            <Toolbar className="bg-transparent border-0 p-0 mb-4" start={startToolBar} />
            <Card
                className="shadow-lg rounded-lg border border-blue-200 overflow-hidden card_content_padding "
                style={{ backgroundColor: mode?.backgroundSecondaryColor, color: mode?.color, padding: '0rem' }}>
                <Toast ref={toast} />

                <div className="p-2">
                    {/* Main Settings Section */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                        <div className="space-y-2">
                            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                                From Address
                            </label>
                            <InputText
                                className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                value={fromAdd}
                                onChange={(e) => setFromAdd(e.target.value)}
                            />
                        </div>

                        <div className="space-y-2">
                            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                                From Display Name
                            </label>
                            <InputText
                                className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                value={displayName}
                                onChange={(e) => setDisplayName(e.target.value)}
                            />
                        </div>

                        <div className="space-y-2">
                            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                                Host
                            </label>
                            <InputText
                                className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                value={host}
                                onChange={(e) => setHost(e.target.value)}
                            />
                        </div>

                        <div className="space-y-2 input_number">
                            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                                Port
                            </label>
                            <InputNumber
                                inputClassName="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                value={port}
                                onChange={(e: any) => setPort(e.value)}
                            />
                        </div>

                        <div className="space-y-2">
                            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                                Username
                            </label>
                            <InputText
                                className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                value={userName}
                                onChange={(e) => setUserName(e.target.value)}
                            />
                        </div>

                        <div className="space-y-2">
                            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                                Password
                            </label>
                            <InputText
                                className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                        </div>
                    </div>

                    {/* Checkbox + Save Section */}
                    <div className="flex flex-col sm:flex-row items-center gap-6 mb-6">
                        {/* Left side checkboxes */}
                        <div className="flex flex-col sm:flex-row gap-6">
                            <div className="flex items-center space-x-2">
                                <Checkbox
                                onChange={(e: any) => setSsl(ssl ? false : true)}
                                checked={ssl ? true : false}
                            />
                            <label className="text-sm font-medium text-gray-700 dark:text-gray-300">
                                Use SSL
                            </label>
                            </div>

                            <div className="flex items-center space-x-2">
                                  <Checkbox
                                onChange={(e: any) => setSsl(ssl ? false : true)}
                                checked={ssl ? false : true}
                            />
                            <label className="text-sm font-medium text-gray-700 dark:text-gray-300">
                                Use Default Credentials
                            </label>
                            </div>
                        </div>

                        {/* Right side Save button */}
                        <div className="ml-auto">
                            <Button
                                label="Save"
                                onClick={handleSave}
                                className="w-[90px] px-6 py-2 bg-gold text-white rounded-md transition-colors duration-200"
                            />
                        </div>
                    </div>

                    <Divider className="my-6" />

                    {/* Test Email Section */}
                    <div className="flex flex-col sm:flex-row items-end gap-4">
                        <div className="flex-1 space-y-2 w-full">
                            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                                Test Email Address
                            </label>
                            <InputText
                                className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                value={toAdd}
                                placeholder="To Address"
                                onChange={(e) => setToAdd(e.target.value)}
                            />
                        </div>

                        <div className="flex gap-3 w-full sm:w-auto flex-wrap">
                            <Button
                                label="Send Test Mail"
                                disabled={disableBtn}
                                onClick={handleTestMail}
                                className="sm:w-[180px] w-full px-6 py-2 bg-transparent text-gold disabled:bg-gray-400 disabled:cursor-not-allowed text-white rounded-md transition-colors duration-200 sm:flex-none"
                            />
                        </div>
                    </div>
                </div>
            </Card>
        </div>
    );
}